import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { Button, ButtonType, DialogHeader } from '@checkmarx/cx-ui';
import Dialog from 'material-ui/Dialog';

@inject('translationsStore')
export default class ConfirmationDialog extends Component {
    
    render() {

        const customContentStyle = {
            width: '475px',
            backgroundColor: '#FFFFFF'
        };

        const { cancelButtonText, confirmButtonType, onButtonClick, buttonText, inProgress,
                    titleText, onCancelClick, closeClick, open, contentText, translationsStore } = this.props;

        const actions = [
            onCancelClick && <span className='portal-blank-button' onClick={onCancelClick}>
                {
                    cancelButtonText ? cancelButtonText : translationsStore.translate('CANCEL')
                }
            </span>,
            <Button 
                buttonType={confirmButtonType ? confirmButtonType : ButtonType.blue}
                onClick={onButtonClick}
                text={buttonText}
                inProgress={inProgress}>
            </Button>
        ];

        const title = <DialogHeader 
                        title={titleText}
                        closeClick={closeClick}
                        displayCloseButton={closeClick ? true : false}  
                    />;

        return (
            <Dialog
                title={title}
                className='portal-confirm-dialog'
                bodyClassName='portal-confirm-dialog-body'
                actionsContainerClassName='portal-confirm-dialog-actions'
                actions={actions}
                modal={true}
                contentStyle={customContentStyle}
                open={open}>
                <div>
                    {contentText}
                </div>
            </Dialog>
        );
    }    
}